module.exports = {
    Website: require('./WebsiteGraph'),
    Account: require('./AccountGraph'),
    Insights: require('./InsightsGraph'),
    Event: require('./EventGraph'),
    Ems: require('./EmsGraph'),
    Content: require('./ContentGraph'),
    Blog: require('./BlogGraph'),
    Shop: require('./ShopGraph'),
    Helpdesk: require('./HelpdeskGraph'),
    Godaddy: require('./GodaddyGraph'),
    Core: require('./CoreGraph'),
    Yfp: require('./YfpGraph'),
    Notification: require('./NotificationGraph'),
    Contacts: require('./ContactGraph'),
    Learnearn: require('./TrackerGraph'),
    Webinar: require('./WebinarGraph'),
    Newsletter: require('./NewsletterGraph'),
    Course: require('./CourseGraph'),
    Promo: require('./PromoGraph'),
    Sendible: require('./SendibleGraph')
}